module.exports = "<div class=\"content\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <h5>The page you requested was not found.</h5>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Fed/src/app/shared/components/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/shared/components/page-not-found/page-not-found.component.html
// module chunks = main